import { useInfiniteQuery } from "@tanstack/react-query";
import { customAxios } from "lib/axios";

type IssueHistoryEntry = {
  _id: string;
  issueId: string;
  issueTitle: string;
  user: string;
  mutation: "create" | "update" | "delete";
  updatedFields: string[];
  date: string;
  isDeleted: boolean;
};

type IssueHistoryResponse = {
  nextPage?: number;
  data: IssueHistoryEntry[];
};

export type IssueHistoryBody = {
  projectId: string;
  issueId: string;
};

const getIssueHistory = async ({
  projectId,
  issueId,
  pageParam = 1,
}: IssueHistoryBody & {
  pageParam?: number;
}): Promise<IssueHistoryResponse> => {
  const { data } = await customAxios.post<IssueHistoryResponse>(
    `/projects/issue-history`,
    {
      projectId,
      issueId,
      page: pageParam,
    }
  );
  return data;
};

export const useGetIssueHistory = (projectId?: string, issueId?: string) =>
  useInfiniteQuery({
    queryKey: ["issue-history", projectId, issueId],
    queryFn: ({ pageParam = 1 }) =>
      getIssueHistory({
        projectId: projectId!,
        issueId: issueId!,
        pageParam: pageParam as number,
      }),
    enabled: !!projectId && !!issueId,
    getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
  });
